import { AiUserSubscription } from './AiUser'
import { InstanceDetails, MLFeedback } from './MLInferenceJob'
import { BaseModel } from './common'

export enum MLJobStatus {
  RUNNING = 'running',
  SUCCESS = 'success',
  ERROR = 'error',
  CANCELLED = 'cancelled'
}

export enum CallbackCheckpointType {
  // Indicates the UVR phase of the job has completed, and the
  // job was queued up on the next phase instance type.
  UVR_COMPLETE = 'uvr-complete',
  // Indicates the job was interrupted, and had to be requeued on the
  // same instance type.
  REQUEUE = 'requeue'
}

export interface MLJobTimingDetails {
  totalMs?: number
  inferMs?: number
  modelFileDownloadMs?: number
  indexFileDownloadMs?: number
  splitInstrumentalMs?: number
  splitHarmonyMs?: number
  dereverbMs?: number
}

export interface BaseMLModelJob extends BaseModel {
  jobStatus: MLJobStatus
  downloadedAt: string | null
  downloadedAtTier: AiUserSubscription | null
  downloadedAtCost: number | null
  logMessages: string[]
  jobStartTime: string | null
  jobEndTime: string | null
  instanceDetails: InstanceDetails | null
  timingMs: MLJobTimingDetails | null
  feedback: MLFeedback | null
  feedbackComment: string | null
  aiUserId: number
}
